import { render, staticRenderFns } from "./ViewRequestComponent.vue?vue&type=template&id=5ffe046a"
import script from "./ViewRequestComponent.vue?vue&type=script&lang=js"
export * from "./ViewRequestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports